<!-- TEMPLATE -->
<template>
  <div :class="deanInputSelectMultiClass">
    <div class="row">
      <div class="small-12 medium-12 large-12 hd-12 columns">
        <dean-input-select
          :id="id"
          :title="title"
          :data="tempData"
          @selected-value="addItem"
          fill-width
        >
        </dean-input-select>
      </div>
      <div v-if="value" class="small-12 medium-12 large-12 hd-12 columns">
        <transition-group class="selected-container" name="fade">
          <span v-for="item in value" :key="item.label">
            <span class="selected-item">
              <span class="selected-item-text">{{ item.label }}</span>
              <dean-icon
                @click.native="removeItem(item)"
                class="selected-item-close"
                :glyph="closeIcon"
                width="18"
                height="18"
              >
              </dean-icon>
            </span>
          </span>
        </transition-group>
      </div>
    </div>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';

// SVG
import goToIcon from '../svg/feather-icons/corner-up-right.svg';
import closeIcon from '../svg/feather-icons/x.svg';

import deanInputSelect from './deanInputSelect.vue';
import deanIcon from './deanIcon.vue';

@Component({
  components: {
    deanInputSelect,
    deanIcon
  }
})
export default class deanInputSelectMulti extends Vue {
  // PROPS
  @Prop() data!: Array<any>;
  @Prop() selected!: Array<any>;
  @Prop({ default: '' }) title!: string;
  @Prop({ default: 'deanInputMultiSelect' }) id!: string;
  @Prop({ default: false }) fillWidth!: boolean;

  // DATA
  closeIcon: object = closeIcon;
  value: Array<any> = [];
  tempData: Array<any> = [];
  selectedData: object = {};

  // COMPUTED
  get deanInputSelectMultiClass() {
    let value = 'dean-input-select-multi ';
    if (this.fillWidth) value += ` fill-width`;
    return value;
  }

  @Watch('selected')
  updatedValue() {
    // MAP VALUE
    if (this.selected) {
      this.value = this.selected.map(row => {
        return {
          label: row.label,
          value: row.value,
          disabled: true
        };
      });
    }

    // MAP DATA
    this.tempData = this.data.map(row => {
      if (
        row.disabled == undefined ||
        row.disabled == null ||
        row.disabled == ''
      ) {
        return {
          label: row.label,
          value: row.value,
          disabled: false
        };
      } else {
        return {
          label: row.label,
          value: row.value,
          disabled: row.disabled
        };
      }
    });

    // UPDATE TEMP DATA
    for (let item in this.value) {
      for (let key in this.tempData) {
        if (
          JSON.stringify(this.value[item].value) ==
          JSON.stringify(this.tempData[key].value)
        ) {
          this.tempData[key].disabled = true;
        }
      }
    }
  }

  //METHODS
  addItem(item: { [key: string]: any }) {
    if (item.selected != null) {
      this.value.push(item.selected);

      for (let key in this.tempData) {
        if (
          JSON.stringify(item.selected.value) ==
          JSON.stringify(this.tempData[key].value)
        ) {
          this.tempData[key].disabled = true;
        }
      }

      const data = {
        id: this.id,
        value: this.value,
        data: this.tempData.map(row => {
          return {
            label: row.label,
            value: row.value,
            active: row.disabled
          };
        })
      };

      this.$emit('selected', data);
      this.selectedData = item.selected;
    }
  }

  removeItem(item: { [key: string]: any }) {
    let value: Array<any> = [];

    for (let key in this.value) {
      if (this.value[key] != item) {
        if (item != null) {
          value.push(this.value[key]);
        }
      }
    }

    this.value = value;

    for (let key in this.tempData) {
      if (
        JSON.stringify(item.value) == JSON.stringify(this.tempData[key].value)
      ) {
        this.tempData[key].disabled = false;
      }
    }
    const data = {
      id: this.id,
      value: this.value,
      data: this.tempData.map(row => {
        return {
          label: row.label,
          value: row.value,
          active: row.disabled
        };
      })
    };

    this.$emit('selected', data);
  }

  mounted() {
    this.updatedValue();
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import '../scss/vars';

// DEAN WIDGET
.dean-input-select-multi {
  position: relative;

  .selected-container {
    @include display-flex();
    justify-content: flex-start;
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
    padding: 5px;

    .selected-item {
      @include display-flex();
      justify-content: flex-start;
      padding: 11px 10px 11px 20px;
      margin: 5px;
      @include border-radius(100px);
      color: black;
      background: var(--color-light-shade-2, $color-light-shade-2);
      word-break: break-all;

      .selected-item-text {
        padding-right: 10px;
      }

      .selected-item-close {
        fill: var(--color-dark-shade-4, $color-dark-shade-4);
        padding: 2px;
        min-height: 18px;
        height: 18px;
        min-width: 18px;
        width: 18px;
        cursor: pointer;
        transition: 0.5s;
        &:hover {
          fill: var(--color-primary, $color-primary);
        }
      }
    }
  }
}
.fill-width {
  width: 100%;
}
</style>
